export default "__VITE_ASSET__C_K52KHr__"